import { Component, OnInit, Input } from '@angular/core';
import { httpService } from '../service/servicio';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-datosposiciones',
  templateUrl: './datosposiciones.component.html',
  styleUrls: ['./datosposiciones.component.css']
})

export class DatosposicionesComponent {

    constructor(public http:httpService, public app: AppComponent, public toastr: ToastsManager, vcr: ViewContainerRef) {

        this.toastr.setRootViewContainerRef(app.vcr);

        if (this.http.posicionGrabar.Id == 0)  this.tituloPosicion = "Nueva Posición";
        this.http.sw.mostrarPosiciones = false;
        this.descargarClientes();

     }


    @Input() clientes:any;

    tituloPosicion:string = 'Editando Posicion número: ' + this.http.posicionGrabar.Id;

    clienteactual:any;
    posicionactual:any;

    loaded:boolean = false;
    cloaded:number = 0;


    volver() {
      this.http.sw.mostrarDatosposiciones = false;
      this.http.sw.mostrarMenu = true;
      this.http.sw.mostrarPosiciones = true;
    }

    borrar(){

        this.http.datosPost.action = 2; // borrar maquina
        this.http.datosPost.datos = this.http.posicionGrabar;
        this.http.posicion(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;

          }, err => {
               (err.message);
          }, () => {
              if (this.http.uploaded.Status == 1) {
                    this.toastr.success(this.http.uploaded.Text,'Posición');
                    this.http.descargarPosiciones().subscribe(respuesta => {
                    this.http.sw.mostrarDatosposiciones = false;
                    this.http.sw.mostrarMenu = true;
                    this.http.sw.mostrarPosiciones = true;
                  });
              }else{
                  this.app.showtoast();
                  this.toastr.error(this.http.uploaded.Text,'Posición');
              }
        });

    }

    grabar() {
      this.http.datosPost.action = 1; // por defecto Update
      if (this.http.posicionGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
        this.http.posicionGrabar.Observaciones.replace(/\r?\n/g, "$");
        this.http.datosPost.datos = this.http.posicionGrabar;
        this.http.posicion(this.http.datosPost).subscribe(respuesta => {
            this.http.uploaded = respuesta;

          }, err => {
             (err.message);
          }, () => {
            if (this.http.uploaded.Status == 1) {
                this.toastr.success(this.http.uploaded.Text,'Posición');
                this.http.descargarPosiciones().subscribe(respuesta => {

                  this.http.sw.mostrarDatosposiciones = false;
                  this.http.sw.mostrarMenu = true;
                  this.http.sw.mostrarPosiciones = true;


                });
            }else{
                this.toastr.error(this.http.uploaded.Text,'Maquinas');
            }
      });

    }


      descargarClientes() {

                  this.http.descargarClientes()
                  .subscribe(cliente => {
                       this.clientes = cliente;

                       this.clienteactual = this.clientes.find(cliente => cliente.Id ===  this.http.posicionGrabar.cliente);

                  }, err => {
                     (err.message);
                  }, () => {
                    if ((this.http.posicionGrabar.Id == 0|| ( this.clienteactual == null) ) ) {
                      this.http.posicionGrabar.cliente = this.clientes[0].Id;

                    }
                    this.http.sw.mostrarPosiciones = false;
                    this.http.sw.mostrarMenu = false;
                     ('completed');

                  });
        }


      selCliente(Id) {

          this.http.posicionGrabar.cliente = Id;
           
      }

  }



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/datosposiciones/datosposiciones.component.ts